import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createSlots as _createSlots } from "vue"

const _hoisted_1 = { style: {"font-weight":"bold","padding-bottom":"4px"} }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "Warehouse Management Team will confirm in OA", -1)
const _hoisted_3 = { class: "flex cos-both-form-item" }
const _hoisted_4 = { class: "flex cos-both-form-item" }
const _hoisted_5 = { class: "flex cos-both-form-item" }

import { computed, onMounted, watch, ref, PropType, reactive } from 'vue'
import MultipleItem from '@/components/CosViewContent/multipleItem.vue'
import { listByParamCodes } from '@/api/common'
import type { PotentialItem } from '@/typings/api/customerCenter'
import { DcConfirm, DcMessage, message } from '@dc-platform/dc-components'
import { useRoute } from 'vue-router'
import { goBack } from '@/hooks/cosRouter'
import { usePermissionStore } from '@/stores/permission'
import { cloneDeep } from 'lodash-es'
import { initObjectVal, paramCodesDataFilter } from '@/utils/index'

import { useI18n } from 'vue-i18n'
import UploadFile from '@/components/UploadFile'
import CosTable from '@/components/CosTable/src/cosTable.vue'
import {
  newClientEvaluationCreate, newClientEvaluationDraft,
  newClientEvaluationEdit
} from '@/api/overseasSales/newClientEvaluation'
import SerialSelect from '@/views/overseasSales/customerCenter/components/serialSelect.vue'
import CosInput from '@/components/Antd/CosInput/index.vue'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'

const __default__ = { name: 'accountActivationBaseMessage' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  disabled: {
    type: Boolean,
    default: true
  },
  reviewHistory: {
    type: Array
  },
  data: {
    type: Object as PropType<PotentialItem>,
    default: () => {
      return {
        business: {},
        contact: {}
      }
    }
  },
  permissionPage: {
    type: Object,
    default: () => {
      return {}
    }
  },
  formItemView: {
    type: Boolean
  },
  hideOk: {
    type: Boolean
  }
},
  setup(__props) {

const { t } = useI18n()
const permissionStore = usePermissionStore()
const permissionBtn = ref<any[]>(permissionStore.permission)
const route = useRoute()
const initForm = reactive<any>({
  business: {
    businessType: [],
    quotationInfo: { details: [{}] },
    contractInfo: { fixedCredit: {}, registrationFee: {}, monthlyMaintenanceFee: {} }
  },
  contact: {},
  visitAddress: [{}]
})
const resetValue = ref(cloneDeep(initForm))
const loading = ref(false)
const reviewHistoryColumns = computed(() => [
  {
    title: t('common.operator'),
    dataIndex: 'operatorName'
  },
  {
    title: t('common.operatorDate'),
    dataIndex: 'createTime',
    type: 'time'
  },
  {
    title: t('clue.当前审核意见'),
    dataIndex: 'processSuggject',
    ellipsis: false
  }
])
const cosId = computed(() => form.value.cosId)
const form = ref<any>(cloneDeep(initForm))
const props = __props
watch(
  () => props.data,
  (v, prev) => {
    if (v) {
      const formVal = v
      initObjectVal(formVal, initForm)
      form.value = cloneDeep(formVal)
      resetValue.value = cloneDeep(formVal)
    }
  },
  { immediate: true }
)
const quotationAndBusinessChange = ref<boolean>(false)
// 当【价格类型】选择为【公布价】且【业务类型】选择为【仓储服务】或【头程+仓储】时
watch(
  () => [form.value.business.quotationInfo.quotationType, form.value.business.businessTypeSelect],
  (newValue, oldValue) => {
    const [quotationType, businessTypeSelect] = newValue
    quotationAndBusinessChange.value = (quotationType === 3468) &&
      (businessTypeSelect === 3438 || businessTypeSelect === 3441)
  },
  { immediate: true, deep: true }
)
watch(
  () => form.value.business.contractInfo?.paymentType,
  (newValue, oldValue) => {
    if (newValue === 3504 || newValue === 3473) {
      if (!form.value.business.contractInfo.paymentTerm) {
        form.value.business.contractInfo.paymentTerm = '10'
      }
    }
  },
  { immediate: true, deep: true }
)
const queryAccountActivationId = computed(() => route.query.accountActivationId as unknown as number)
// 是否是再次提交审核 只要等于1 就是
const review = computed(() => route.query.review as string)
const formRef = ref()
const paramCodeData = ref<any>({
  ofbu_sales_category: [], // 销售品类
  ofbu_product_type: [], // 货物类型
  ofbu_warehouse: [], // 合作海外仓
  ofbu_sale_platform: [], // 在售电商平台
  ofbu_service_demand: [], // 服务需求
  ofbu_payment_type: [], // 付款方式
  ofbu_billing_term: [], // 出账周期
  ofbu_demand_info: [], // 需求海外仓
  ofbu_erp_info: [], // 目前使用ERP
  ofbu_quotation_type: [], // 价格类型
  ofbu_replenish_frequency: [], // 头程补货频次
  ofbu_business_type: [], // 客户业务类型
  ofbu_marketing_activity: [], // 关联市场活动
  ofbu_head_replenish_method: [], // 头程补货方式
  ofbu_area_code: [], // 电话区号
  ofbu_customer_size: [], // 客户规模
  ofbu_service_body: [], // 服务公司
  ofbu_currency: [] // 币种
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_ofbu',
    paramCodes: [
      'ofbu_sales_category',
      'ofbu_product_type',
      'ofbu_warehouse',
      'ofbu_sale_platform',
      'ofbu_service_demand',
      'ofbu_payment_type',
      'ofbu_billing_term',
      'ofbu_demand_info',
      'ofbu_erp_info',
      'ofbu_quotation_type',
      'ofbu_replenish_frequency',
      'ofbu_business_type',
      'ofbu_marketing_activity',
      'ofbu_head_replenish_method',
      'ofbu_area_code',
      'ofbu_customer_size',
      'ofbu_service_body',
      'ofbu_sign_in_address_label',
      'ofbu_currency'
    ]
  }).then((res) => {
    if (res.code === 200) {
      if (!props.disabled) {
        // 递归过滤业务参数状态
        res.data = paramCodesDataFilter(res.data, 0)
      }
      paramCodeData.value = res.data
    }
  })
}
onMounted(() => {
  getByParamCodes()
})
// 去除数组null ''
const clear = (arr: any[], keys: string[]) => {
  if (!arr) {
    return []
  }
  let result: any = []
  arr.forEach((v: any) => {
    for (let i = 0; i < keys.length; i++) {
      const k = keys[i]
      if (v[k] != null && v[k] !== '') {
        result.push(v)
        break
      }
    }
  })
  if (!result.length) {
    result = [{}]
  }
  return result
}
// 点击暂存
const handleSaveToDraft = async () => {
  if (!form.value.customerName) {
    DcMessage.error(t('tips.customerEnterTips'))
    formRef.value?.validate('customerName')
    return
  }
  formRef.value?.validate('customerName').then(() => {
    DcConfirm.warning({
      cancelText: t('btn.cancel'),
      content: t('tips.saveOaDraft', {
        oaTypeStr: t('common.客户激活')
      }),
      okText: t('btn.sure'),
      onOk() {
        saveDraft()
      }
    })
  })
}
// 保存草稿
const saveDraft = async () => {
  loading.value = true
  const p = cloneDeep(form.value)
  p.skipReview = false
  if (p.business.businessTypeSelect) {
    p.business.businessType = [p.business.businessTypeSelect]
    p.business.businessTypeSelect = undefined
  }
  try {
    p.applyType = 2
    const data = await newClientEvaluationDraft(p, { custom: { errorMsg: false } })
    if (data.code === 200) {
      message.success(t('tips.saveSuccess'))
      goBack()
    } else {
      message.error(data.message)
    }
  } catch (error) {
  }
  loading.value = false
}
const handleSubmit = async () => {
  formRef.value?.validate().then(async () => {
    loading.value = true

    const p = cloneDeep(form.value)
    p.skipReview = false
    if (p.business.businessTypeSelect) {
      p.business.businessType = [p.business.businessTypeSelect]
      p.business.businessTypeSelect = undefined
    }
    try {
      // 这里判断是否再次提交评审id传进来，如果是空的那么一定是新增或者是草稿的详情
      if (queryAccountActivationId.value) {
        const data = await newClientEvaluationEdit(p)
        if (data.code === 200) {
          message.success(t('tips.activitySuccess'))
          goBack()
        } else {
          message.error(data.message)
        }
      } else {
        p.applyType = 2
        const data = await newClientEvaluationCreate(p, { custom: { errorMsg: false } })
        if (data.code === 200) {
          message.success(t('tips.addSuccess'))
          goBack()
        } else {
          message.error(data.message)
        }
      }
    } catch (error) {}
    loading.value = false
  })
}

// 新增列
const handleAddCol = (arr: {}[]) => {
  arr.push({})
}
// 删除列
const handleDelCol = (arr: {}[], index: number) => {
  arr.splice(index, 1)
}

return (_ctx: any,_cache: any) => {
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_dc_layout_card = _resolveComponent("dc-layout-card")!
  const _component_ParamCodesSelect = _resolveComponent("ParamCodesSelect")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_CosInputNumber = _resolveComponent("CosInputNumber")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_CosTextarea = _resolveComponent("CosTextarea")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_footer_button = _resolveComponent("cos-footer-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_form, {
      ref_key: "formRef",
      ref: formRef,
      name: "advanced_search",
      model: form.value
    }, {
      default: _withCtx(() => [
        _createVNode(_component_dc_layout_card, {
          title: _unref(t)('common.baseTabs')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_dc_form_item, {
              name: "customerName",
              label: _unref(t)('custom.customerName'),
              rules: {
          message: _unref(t)('common.pleaseInput'),
          required: true
        }
            }, {
              default: _withCtx(() => [
                _createVNode(CosInput, {
                  value: form.value.customerName,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((form.value.customerName) = $event)),
                  maxlength: 50,
                  view: __props.formItemView
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('custom.customerNumber'),
              name: "customerNumber",
              rules: {
                message: _unref(t)('common.pleaseSelect'),
                required: true
              }
            }, {
              default: _withCtx(() => [
                _createVNode(SerialSelect, {
                  value: form.value.customerNumber,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((form.value.customerNumber) = $event)),
                  cosId: _unref(route).query.cosId,
                  view: __props.formItemView,
                  requiredCosId: true
                }, null, 8, ["value", "cosId", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              name: "customerWebsite",
              label: _unref(t)('custom.officialWeb'),
              rules: {
               message: _unref(t)('common.pleaseInput'),
               required: true
             }
            }, {
              default: _withCtx(() => [
                _createVNode(CosInput, {
                  value: form.value.customerWebsite,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((form.value.customerWebsite) = $event)),
                  valueModifiers: { trim: true },
                  maxlength: 200,
                  disabled: __props.disabled,
                  view: __props.formItemView
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              name: "registerEmail",
              label: _unref(t)('custom.regEmail'),
              rules: {
              message: _unref(t)('common.pleaseInput'),
              required: true
             }
            }, {
              default: _withCtx(() => [
                _createVNode(CosInput, {
                  value: form.value.registerEmail,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((form.value.registerEmail) = $event)),
                  valueModifiers: { trim: true },
                  maxlength: 200,
                  disabled: __props.disabled,
                  view: __props.formItemView
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            (form.value.applyNo)
              ? (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 0,
                  name: "applyNo",
                  label: _unref(t)('custom.申请单号'),
                  rules: { required: true }
                }, {
                  default: _withCtx(() => [
                    _createVNode(CosInput, {
                      value: form.value.applyNo,
                      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((form.value.applyNo) = $event)),
                      valueModifiers: { trim: true },
                      disabled: "",
                      view: __props.formItemView
                    }, null, 8, ["value", "view"])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(_component_dc_layout_card, {
          title: _unref(t)('custom.业务需求')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('custom.业务类型'),
              name: ['business', 'businessTypeSelect'],
              rules: {
          message: _unref(t)('common.pleaseSelect'),
          required: true
        }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  value: form.value.business.businessTypeSelect,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((form.value.business.businessTypeSelect) = $event)),
                  options: paramCodeData.value.ofbu_business_type,
                  disabled: __props.disabled,
                  view: __props.formItemView,
                  allowClear: ""
                }, null, 8, ["value", "options", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('custom.区域仓'),
              name: ['business', 'regionalWarehouse'],
              rules: {
          message: _unref(t)('common.pleaseSelect'),
          required: true
        }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  value: form.value.business.regionalWarehouse,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((form.value.business.regionalWarehouse) = $event)),
                  options: paramCodeData.value.ofbu_demand_info,
                  disabled: __props.disabled,
                  view: __props.formItemView,
                  allowClear: "",
                  mode: "multiple"
                }, null, 8, ["value", "options", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"])
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(_component_dc_layout_card, {
          title: _unref(t)('custom.报价'),
          span: 6
        }, _createSlots({
          default: _withCtx(() => [
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('custom.价格类型'),
              name: ['business', 'quotationInfo', 'quotationType'],
              rules: {
          message: _unref(t)('common.pleaseSelect'),
          required: true
        }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  value: form.value.business.quotationInfo.quotationType,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((form.value.business.quotationInfo.quotationType) = $event)),
                  options: paramCodeData.value.ofbu_quotation_type,
                  disabled: __props.disabled,
                  view: __props.formItemView,
                  allowClear: ""
                }, null, 8, ["value", "options", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            (quotationAndBusinessChange.value)
              ? (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 0,
                  name: ['business', 'quotationInfo', 'fulfillmentRatesVersion'],
                  label: _unref(t)('custom.仓储报价版本'),
                  rules: {
              message: _unref(t)('common.pleaseInput'),
              required: quotationAndBusinessChange.value
            }
                }, {
                  default: _withCtx(() => [
                    _createVNode(CosInput, {
                      value: form.value.business.quotationInfo.fulfillmentRatesVersion,
                      "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((form.value.business.quotationInfo.fulfillmentRatesVersion) = $event)),
                      valueModifiers: { trim: true },
                      maxlength: 200,
                      disabled: __props.disabled,
                      view: __props.formItemView
                    }, null, 8, ["value", "disabled", "view"])
                  ]),
                  _: 1
                }, 8, ["label", "rules"]))
              : _createCommentVNode("", true),
            (quotationAndBusinessChange.value)
              ? (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 1,
                  name: ['business', 'quotationInfo', 'shippingRatesVersion'],
                  label: _unref(t)('custom.尾程报价版本'),
                  rules: {
              message: _unref(t)('common.pleaseInput'),
              required: quotationAndBusinessChange.value
            }
                }, {
                  default: _withCtx(() => [
                    _createVNode(CosInput, {
                      value: form.value.business.quotationInfo.shippingRatesVersion,
                      "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((form.value.business.quotationInfo.shippingRatesVersion) = $event)),
                      valueModifiers: { trim: true },
                      maxlength: 200,
                      disabled: __props.disabled,
                      view: __props.formItemView
                    }, null, 8, ["value", "disabled", "view"])
                  ]),
                  _: 1
                }, 8, ["label", "rules"]))
              : _createCommentVNode("", true),
            (form.value.business.quotationInfo.quotationType === 3469)
              ? (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 2,
                  name: ['business', 'quotationInfo', 'priceDocuments'],
                  label: _unref(t)('custom.报价策略'),
                  rules: { required: form.value.business.quotationInfo.quotationType === 3469, message: _unref(t)('common.pleaseInput') }
                }, {
                  default: _withCtx(() => [
                    _createVNode(CosInput, {
                      value: form.value.business.quotationInfo.priceDocuments,
                      "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((form.value.business.quotationInfo.priceDocuments) = $event)),
                      valueModifiers: { trim: true },
                      maxlength: 200,
                      disabled: __props.disabled,
                      view: __props.formItemView
                    }, null, 8, ["value", "disabled", "view"])
                  ]),
                  _: 1
                }, 8, ["label", "rules"]))
              : _createCommentVNode("", true),
            (quotationAndBusinessChange.value)
              ? (_openBlock(), _createBlock(MultipleItem, {
                  key: 3,
                  view: __props.formItemView
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value.business.quotationInfo.details, (item, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _createElementVNode("p", _hoisted_1, _toDisplayString(`${_unref(t)('custom.区域仓')}${index+1}`), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_dc_form_item, {
                          label: _unref(t)('custom.区域仓'),
                          name: ['business', 'quotationInfo', 'details', index, 'regionalWarehouse'],
                          span: 3,
                          rules: {
              message: _unref(t)('common.pleaseSelect'),
              required: true
            }
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ParamCodesSelect, {
                              value: item.regionalWarehouse,
                              "onUpdate:value": ($event: any) => ((item.regionalWarehouse) = $event),
                              options: paramCodeData.value.ofbu_demand_info,
                              disabled: __props.disabled,
                              view: __props.formItemView,
                              allowClear: ""
                            }, null, 8, ["value", "onUpdate:value", "options", "disabled", "view"])
                          ]),
                          _: 2
                        }, 1032, ["label", "name", "rules"]),
                        _createVNode(_component_dc_form_item, {
                          name: ['business', 'quotationInfo', 'details', index, 'subWarehouseCode'],
                          label: _unref(t)('custom.物理仓'),
                          span: 3
                        }, {
                          label: _withCtx(() => [
                            _createVNode(_component_a_tooltip, {
                              placement: "topLeft",
                              overlayStyle: { maxWidth: '800px' }
                            }, {
                              title: _withCtx(() => [
                                _hoisted_2
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("span", null, _toDisplayString(_unref(t)('custom.物理仓')), 1),
                                _createVNode(_unref(ExclamationCircleOutlined), { style: {"margin-left":"2px","font-size":"14px"} })
                              ]),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _createVNode(CosInput, {
                              value: item.subWarehouseCode,
                              "onUpdate:value": ($event: any) => ((item.subWarehouseCode) = $event),
                              valueModifiers: { trim: true },
                              maxlength: 200,
                              disabled: "",
                              ignorePlaceHolder: "",
                              view: __props.formItemView
                            }, null, 8, ["value", "onUpdate:value", "view"])
                          ]),
                          _: 2
                        }, 1032, ["name", "label"]),
                        _createVNode(_component_dc_form_item, {
                          name: ['business', 'quotationInfo', 'details', index, 'storageFeeDiscount'],
                          label: _unref(t)('custom.仓租折扣(%)'),
                          span: 3,
                          rules: {
              message: _unref(t)('common.pleaseInput'),
              required: true
            }
                        }, {
                          default: _withCtx(() => [
                            _createVNode(CosInput, {
                              value: item.storageFeeDiscount,
                              "onUpdate:value": ($event: any) => ((item.storageFeeDiscount) = $event),
                              valueModifiers: { trim: true },
                              maxlength: 200,
                              disabled: __props.disabled,
                              view: __props.formItemView
                            }, null, 8, ["value", "onUpdate:value", "disabled", "view"])
                          ]),
                          _: 2
                        }, 1032, ["name", "label", "rules"]),
                        _createVNode(_component_dc_form_item, {
                          name: ['business', 'quotationInfo', 'details', index, 'handingFeeDiscount'],
                          label: _unref(t)('custom.操作费折扣(%)'),
                          span: 3,
                          rules: {
              message: _unref(t)('common.pleaseInput'),
              required: true
            }
                        }, {
                          default: _withCtx(() => [
                            _createVNode(CosInput, {
                              value: item.handingFeeDiscount,
                              "onUpdate:value": ($event: any) => ((item.handingFeeDiscount) = $event),
                              valueModifiers: { trim: true },
                              maxlength: 200,
                              disabled: __props.disabled,
                              view: __props.formItemView
                            }, null, 8, ["value", "onUpdate:value", "disabled", "view"])
                          ]),
                          _: 2
                        }, 1032, ["name", "label", "rules"]),
                        _createVNode(_component_dc_form_item, {
                          name: ['business', 'quotationInfo', 'details', index, 'shippingFeeDiscount'],
                          label: _unref(t)('custom.尾程折扣(%)'),
                          span: 3,
                          rules: {
              message: _unref(t)('common.pleaseInput'),
              required: true
            }
                        }, {
                          default: _withCtx(() => [
                            _createVNode(CosInput, {
                              value: item.shippingFeeDiscount,
                              "onUpdate:value": ($event: any) => ((item.shippingFeeDiscount) = $event),
                              valueModifiers: { trim: true },
                              maxlength: 200,
                              disabled: __props.disabled,
                              view: __props.formItemView
                            }, null, 8, ["value", "onUpdate:value", "disabled", "view"])
                          ]),
                          _: 2
                        }, 1032, ["name", "label", "rules"]),
                        _createVNode(_component_dc_form_item, {
                          name: ['business', 'quotationInfo', 'details', index, 'remark'],
                          label: _unref(t)('common.remark'),
                          span: 6
                        }, {
                          default: _withCtx(() => [
                            _createVNode(CosInput, {
                              value: item.remark,
                              "onUpdate:value": ($event: any) => ((item.remark) = $event),
                              maxlength: 2000,
                              disabled: __props.disabled,
                              view: __props.formItemView
                            }, null, 8, ["value", "onUpdate:value", "disabled", "view"])
                          ]),
                          _: 2
                        }, 1032, ["name", "label"]),
                        (
                        !__props.formItemView &&
                        form.value.business.quotationInfo.details &&
                        form.value.business.quotationInfo.details.length > 1
                )
                          ? (_openBlock(), _createBlock(_component_dc_form_item, {
                              key: 0,
                              span: 3
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_button, {
                                  type: "text",
                                  danger: "",
                                  style: {"padding":"0 0 0 12px"},
                                  onClick: ($event: any) => (handleDelCol(form.value.business.quotationInfo.details,index))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t)('btn.del')), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["view"]))
              : _createCommentVNode("", true),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('custom.客户报价/竞对报价'),
              name: ['business', 'quotationInfo', 'competitorPriceDocuments'],
              span: 24
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(UploadFile), {
                  view: __props.formItemView,
                  value: form.value.business.quotationInfo.competitorPriceDocuments,
                  "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((form.value.business.quotationInfo.competitorPriceDocuments) = $event)),
                  valueType: "array"
                }, null, 8, ["view", "value"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 2
        }, [
          (!__props.formItemView)
            ? {
                name: "subTitle",
                fn: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    ghost: "",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (handleAddCol(form.value.business.quotationInfo.details)))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('btn.add')), 1)
                    ]),
                    _: 1
                  })
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["title"]),
        _createVNode(_component_dc_layout_card, {
          title: _unref(t)('custom.合同和账期'),
          span: 6
        }, {
          default: _withCtx(() => [
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('custom.服务公司'),
              name: ['business', 'contractInfo', 'serviceCompany'],
              rules: {
              message: _unref(t)('common.pleaseSelect'),
              required: true
            }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  value: form.value.business.contractInfo.serviceCompany,
                  "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((form.value.business.contractInfo.serviceCompany) = $event)),
                  options: paramCodeData.value.ofbu_service_body,
                  disabled: __props.disabled,
                  view: __props.formItemView,
                  allowClear: ""
                }, null, 8, ["value", "options", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('custom.付款方式'),
              name: ['business', 'contractInfo', 'paymentType'],
              rules: {
              message: _unref(t)('common.pleaseSelect'),
              required: true
            }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  value: form.value.business.contractInfo.paymentType,
                  "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((form.value.business.contractInfo.paymentType) = $event)),
                  options: paramCodeData.value.ofbu_payment_type,
                  disabled: __props.disabled,
                  view: __props.formItemView,
                  allowClear: ""
                }, null, 8, ["value", "options", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('custom.出账周期(天)'),
              name: ['business', 'contractInfo', 'billingTerm'],
              rules: {
              message: _unref(t)('common.pleaseSelect'),
              required: true
            }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  value: form.value.business.contractInfo.billingTerm,
                  "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((form.value.business.contractInfo.billingTerm) = $event)),
                  options: paramCodeData.value.ofbu_billing_term,
                  disabled: __props.disabled,
                  view: __props.formItemView,
                  allowClear: ""
                }, null, 8, ["value", "options", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            (form.value.business.contractInfo.paymentType === 3504
          || form.value.business.contractInfo.paymentType === 3473)
              ? (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 0,
                  name: ['business', 'contractInfo', 'paymentTerm'],
                  label: _unref(t)('custom.付款周期(天)'),
                  rules: {
              message: _unref(t)('common.pleaseInput'),
              required: form.value.business.contractInfo.paymentType === 3473
            }
                }, {
                  default: _withCtx(() => [
                    _createVNode(CosInput, {
                      value: form.value.business.contractInfo.paymentTerm,
                      "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((form.value.business.contractInfo.paymentTerm) = $event)),
                      valueModifiers: { trim: true },
                      maxlength: 200,
                      disabled: __props.disabled,
                      view: __props.formItemView
                    }, null, 8, ["value", "disabled", "view"])
                  ]),
                  _: 1
                }, 8, ["label", "rules"]))
              : _createCommentVNode("", true),
            (!__props.formItemView && form.value.business.contractInfo.paymentType === 3504)
              ? (_openBlock(), _createBlock(_component_a_col, {
                  key: 1,
                  span: 6
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_a_form_item, {
                        style: {"width":"70%"},
                        label: _unref(t)('custom.固定额度'),
                        name: ['business', 'contractInfo', 'fixedCredit', 'amount'],
                        rules: {
              message: _unref(t)('common.pleaseInput'),
              required: true
            }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CosInputNumber, {
                            value: form.value.business.contractInfo.fixedCredit.amount,
                            "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((form.value.business.contractInfo.fixedCredit.amount) = $event)),
                            maxlength: 15,
                            min: 0,
                            controls: false,
                            view: __props.formItemView,
                            cosType: "money",
                            formatter: (inputValue) => `${inputValue}`.replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                            parser: (inputValue) => inputValue.replace(/\$\s?|(,*)/g, '')
                          }, null, 8, ["value", "view", "formatter", "parser"])
                        ]),
                        _: 1
                      }, 8, ["label", "rules"]),
                      _createVNode(_component_a_form_item, {
                        label: "fixedCreditCurrency",
                        style: {"width":"30%"},
                        name: ['business', 'contractInfo', 'fixedCredit', 'currency'],
                        class: "hide-label",
                        rules: {
              message: _unref(t)('common.pleaseSelect'),
              required: true
            }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ParamCodesSelect, {
                            options: paramCodeData.value.ofbu_currency,
                            value: form.value.business.contractInfo.fixedCredit.currency,
                            "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((form.value.business.contractInfo.fixedCredit.currency) = $event)),
                            view: __props.formItemView
                          }, null, 8, ["options", "value", "view"])
                        ]),
                        _: 1
                      }, 8, ["rules"])
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (__props.formItemView && form.value.business.contractInfo.paymentType === 3504)
              ? (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 2,
                  label: _unref(t)('custom.固定额度'),
                  name: ['business', 'contractInfo', 'fixedCredit', 'currency'],
                  rules: {
              message: _unref(t)('common.pleaseSelect'),
              required: true
            }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ParamCodesSelect, {
                      cosBeforeDes: form.value.business.contractInfo.fixedCredit.amount?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                      options: paramCodeData.value.ofbu_currency,
                      value: form.value.business.contractInfo.fixedCredit.currency,
                      "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((form.value.business.contractInfo.fixedCredit.currency) = $event)),
                      view: __props.formItemView
                    }, null, 8, ["cosBeforeDes", "options", "value", "view"])
                  ]),
                  _: 1
                }, 8, ["label", "rules"]))
              : _createCommentVNode("", true),
            (!__props.formItemView)
              ? (_openBlock(), _createBlock(_component_a_col, {
                  key: 3,
                  span: 6
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_a_form_item, {
                        style: {"width":"70%"},
                        label: _unref(t)('custom.系统注册费'),
                        name: ['business', 'contractInfo', 'registrationFee', 'amount'],
                        rules: {
              message: _unref(t)('common.pleaseInput'),
              required: true
            }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CosInputNumber, {
                            value: form.value.business.contractInfo.registrationFee.amount,
                            "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((form.value.business.contractInfo.registrationFee.amount) = $event)),
                            maxlength: 15,
                            min: 0,
                            controls: false,
                            view: __props.formItemView,
                            cosType: "money",
                            formatter: (inputValue) => `${inputValue}`.replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                            parser: (inputValue) => inputValue.replace(/\$\s?|(,*)/g, '')
                          }, null, 8, ["value", "view", "formatter", "parser"])
                        ]),
                        _: 1
                      }, 8, ["label", "rules"]),
                      _createVNode(_component_a_form_item, {
                        label: "registrationFeeCurrency",
                        style: {"width":"30%"},
                        name: ['business', 'contractInfo', 'registrationFee', 'currency' ],
                        class: "hide-label",
                        rules: {
              message: _unref(t)('common.pleaseSelect'),
              required: true
            }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ParamCodesSelect, {
                            options: paramCodeData.value.ofbu_currency,
                            value: form.value.business.contractInfo.registrationFee.currency,
                            "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((form.value.business.contractInfo.registrationFee.currency) = $event)),
                            view: __props.formItemView
                          }, null, 8, ["options", "value", "view"])
                        ]),
                        _: 1
                      }, 8, ["rules"])
                    ])
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 4,
                  label: _unref(t)('custom.系统注册费'),
                  name: ['business', 'contractInfo', 'registrationFee', 'currency'],
                  rules: {
              message: _unref(t)('common.pleaseSelect'),
              required: true
            }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ParamCodesSelect, {
                      cosBeforeDes: form.value.business.contractInfo.registrationFee.amount?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                      options: paramCodeData.value.ofbu_currency,
                      value: form.value.business.contractInfo.registrationFee.currency,
                      "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((form.value.business.contractInfo.registrationFee.currency) = $event)),
                      view: __props.formItemView
                    }, null, 8, ["cosBeforeDes", "options", "value", "view"])
                  ]),
                  _: 1
                }, 8, ["label", "rules"])),
            (!__props.formItemView)
              ? (_openBlock(), _createBlock(_component_a_col, {
                  key: 5,
                  span: 6
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_a_form_item, {
                        style: {"width":"70%"},
                        label: _unref(t)('custom.系统管理月费'),
                        name: ['business', 'contractInfo', 'monthlyMaintenanceFee', 'amount'],
                        rules: {
              message: _unref(t)('common.pleaseInput'),
              required: true
            }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CosInputNumber, {
                            value: form.value.business.contractInfo.monthlyMaintenanceFee.amount,
                            "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((form.value.business.contractInfo.monthlyMaintenanceFee.amount) = $event)),
                            maxlength: 15,
                            min: 0,
                            controls: false,
                            view: __props.formItemView,
                            cosType: "money",
                            formatter: (inputValue) => `${inputValue}`.replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                            parser: (inputValue) => inputValue.replace(/\$\s?|(,*)/g, '')
                          }, null, 8, ["value", "view", "formatter", "parser"])
                        ]),
                        _: 1
                      }, 8, ["label", "rules"]),
                      _createVNode(_component_a_form_item, {
                        label: "monthlyMaintenanceFeeCurrency",
                        style: {"width":"30%"},
                        name: ['business', 'contractInfo', 'monthlyMaintenanceFee', 'currency'],
                        class: "hide-label",
                        rules: {
              message: _unref(t)('common.pleaseSelect'),
              required: true
            }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ParamCodesSelect, {
                            options: paramCodeData.value.ofbu_currency,
                            value: form.value.business.contractInfo.monthlyMaintenanceFee.currency,
                            "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((form.value.business.contractInfo.monthlyMaintenanceFee.currency) = $event)),
                            view: __props.formItemView
                          }, null, 8, ["options", "value", "view"])
                        ]),
                        _: 1
                      }, 8, ["rules"])
                    ])
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 6,
                  label: _unref(t)('custom.系统管理月费'),
                  name: ['business', 'contractInfo', 'monthlyMaintenanceFee', 'currency'],
                  rules: {
              message: _unref(t)('common.pleaseSelect'),
              required: true
            }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ParamCodesSelect, {
                      cosBeforeDes: form.value.business.contractInfo.monthlyMaintenanceFee.amount?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                      options: paramCodeData.value.ofbu_currency,
                      value: form.value.business.contractInfo.monthlyMaintenanceFee.currency,
                      "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((form.value.business.contractInfo.monthlyMaintenanceFee.currency) = $event)),
                      view: __props.formItemView
                    }, null, 8, ["cosBeforeDes", "options", "value", "view"])
                  ]),
                  _: 1
                }, 8, ["label", "rules"])),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('custom.客户特殊服务'),
              name: ['business', 'contractInfo', 'additionalServices'],
              rules: {
              message: _unref(t)('common.pleaseSelect'),
              required: true
            }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  value: form.value.business.contractInfo.additionalServices,
                  "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((form.value.business.contractInfo.additionalServices) = $event)),
                  options: paramCodeData.value.ofbu_service_demand,
                  disabled: __props.disabled,
                  view: __props.formItemView,
                  allowClear: "",
                  mode: "multiple"
                }, null, 8, ["value", "options", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              name: ['business', 'contractInfo', 'legalSystemApplicationNo'],
              label: _unref(t)('custom.法务流程编码'),
              rules: {
              message: _unref(t)('common.pleaseSelect'),
              required: true
            }
            }, {
              default: _withCtx(() => [
                _createVNode(CosInput, {
                  value: form.value.business.contractInfo.legalSystemApplicationNo,
                  "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => ((form.value.business.contractInfo.legalSystemApplicationNo) = $event)),
                  valueModifiers: { trim: true },
                  maxlength: 200,
                  disabled: __props.disabled,
                  view: __props.formItemView
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_a_col, { span: 24 }),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('common.remark'),
              span: 12
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosTextarea, {
                  value: form.value.remark,
                  "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => ((form.value.remark) = $event)),
                  maxlength: 2000,
                  view: __props.formItemView
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["title"]),
        (__props.formItemView)
          ? (_openBlock(), _createBlock(_component_dc_layout_card, {
              key: 0,
              title: _unref(t)('custom.审核记录'),
              span: 6
            }, {
              default: _withCtx(() => [
                _createVNode(CosTable, {
                  columns: reviewHistoryColumns.value,
                  style: {"padding":"0 6px 6px 6px"},
                  "data-source": props.reviewHistory,
                  serial: "",
                  rowKey: "nodeId",
                  tableId: "accountActivationReviewHistory",
                  needPage: false,
                  dynamicColumnSetting: false
                }, null, 8, ["columns", "data-source"])
              ]),
              _: 1
            }, 8, ["title"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["model"]),
    (!__props.disabled)
      ? (_openBlock(), _createBlock(_component_cos_footer_button, {
          key: 0,
          value: form.value,
          "onUpdate:value": _cache[29] || (_cache[29] = ($event: any) => ((form).value = $event)),
          resetValue: resetValue.value,
          formRef: formRef.value,
          loading: loading.value,
          disabled: __props.disabled
        }, {
          default: _withCtx(() => [
            (review.value !== '1')
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 0,
                  onClick: handleSaveToDraft,
                  loading: loading.value,
                  s: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('btn.saveOaDraft')), 1)
                  ]),
                  _: 1
                }, 8, ["loading"]))
              : _createCommentVNode("", true),
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: handleSubmit,
              loading: loading.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('btn.save&Submit')), 1)
              ]),
              _: 1
            }, 8, ["loading"])
          ]),
          _: 1
        }, 8, ["value", "resetValue", "formRef", "loading", "disabled"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})